import { USER_MAIL } from "../apiConstant";
import BaseApi from "../baseApi";

class UserMailApi extends BaseApi {
  getPage(param) {
    return this.post(`${USER_MAIL}/page`, param);
  }

  getMemberPage(param) {
    return this.post(`${USER_MAIL}/members`, param);
  }

  changeUnread(param) {
    return this.post(`${USER_MAIL}/read`, param);
  }
}

export default UserMailApi;
